import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import Header from './components/Header/Header';
import RecommendedBadge from './components/RecommendedBadge/RecommendedBadge';
import GridOptions from './components/GridOptions/GridOptions';
import ListOptions from './components/ListOptions/ListOptions';
import FareButton from './components/FareButton/FareButton';
import FooterLinks from './components/FooterLinks/FooterLinks';
import Upgrade from './components/Upgrade/Upgrade';
import { useFareOptions } from '../../model/useFareOptions';
import Taxes from './components/Taxes/Taxes';
import Notification from '../../../../../BaseComponents/Notification';
import { useTranslation } from 'react-i18next';
import FfpBonusInfoBlock from './components/FfpBonusInfoBlock/FfpBonusInfoBlock';
const FareGroupV2 = ({ className, fare, passengerFares, variant, recommended, showUnavailableOptions, disabled, price, originalPrice, priceInMiles, disabledForMiles, subscribed, subscribeOption, onSubscribe, showUpgradeOptions, upgradeOption, onUpgrade, selected, onSelect, onClickRules, onClickConditions, ffpBonusInfo, isFareRulesDisabled, dataTestId }) => {
    var _a, _b;
    const { t } = useTranslation('FareGroup');
    const { FareGroupV2: css } = useTheme('Entities').FareGroupV2;
    const { title, options } = fare;
    const { gridOptions, listOptions } = useFareOptions(options, variant, showUnavailableOptions);
    const showRecommended = recommended && !disabled && !selected;
    const showGridOptions = gridOptions.length;
    const showListOptions = variant === 'small' && listOptions.length > 0;
    const showSubscribe = !subscribed && !!subscribeOption && !!onSubscribe && !disabled;
    const showUpgrade = showUpgradeOptions &&
        upgradeOption &&
        !!onUpgrade &&
        (((_a = upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.canUpgradeTo) === null || _a === void 0 ? void 0 : _a.prices) || ((_b = upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.canUpgradeTo) === null || _b === void 0 ? void 0 : _b.flights)) &&
        !disabled;
    const showFooterLinks = (!!onClickRules || !!onClickConditions) && !disabled;
    const showTaxes = !!priceInMiles && !disabledForMiles && !disabled;
    const showDisabledForMiles = disabledForMiles && !disabled;
    const showFfpBonusInfo = !!ffpBonusInfo && !disabled;
    const handleOnSelect = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!disabled && onSelect) {
            onSelect();
        }
    };
    return (React.createElement("div", { "data-fare-id": fare.id, "data-test-id": dataTestId, className: cn(css.root, className, css[variant], {
            [css.recommended]: recommended,
            [css.disabled]: disabled,
            [css.selected]: selected
        }) },
        showRecommended && React.createElement(RecommendedBadge, null),
        React.createElement("div", { className: css.block__top },
            React.createElement(Header, { title: title, disabled: disabled, price: price, originalPrice: originalPrice, priceInMiles: priceInMiles }),
            showGridOptions && React.createElement(GridOptions, { variant: variant, options: gridOptions }),
            showListOptions && React.createElement(ListOptions, { options: listOptions })),
        React.createElement("div", { className: css.block__bottom },
            showFfpBonusInfo && React.createElement(FfpBonusInfoBlock, Object.assign({}, ffpBonusInfo)),
            showSubscribe && (React.createElement(Upgrade, { variant: "subscribe", upgradeOption: subscribeOption, onUpgrade: onSubscribe })),
            showUpgrade && React.createElement(Upgrade, { variant: "upgrade", upgradeOption: upgradeOption, onUpgrade: onUpgrade }),
            React.createElement(FareButton, { className: css.button, price: price, originalPrice: originalPrice, priceInMiles: priceInMiles, passengerFares: passengerFares, disabled: disabled, selected: selected, subscribed: subscribed, onClick: handleOnSelect }),
            showDisabledForMiles && (React.createElement(Notification, { className: css.notification, type: 'context', status: 'warning', text: t('Not enough miles on your card') })),
            showFooterLinks && (React.createElement(FooterLinks, { isFareRulesDisabled: isFareRulesDisabled, onClickRules: onClickRules, onClickConditions: onClickConditions })),
            showTaxes && React.createElement(Taxes, { price: price }))));
};
export default FareGroupV2;
